import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useMappingProfile = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [failed, setFailed] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const getData = () => {
    setLoading(true);
    axiosClient
      .get(`SettingProduct/MappingProfile/GetAll`)
      .then(res => {
        if (res.status === 200) {
          setData(res.data.value);
          setFailed(false);
        } else {
          enqueueSnackbar(res.data?.message, { variant: 'error' });
          setFailed(true);
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
        setFailed(true);
      })
      .finally(() => setLoading(false));
  };

  return [getData, loading, failed, data];
};

export default useMappingProfile;
